import getImageSrcMap from "@/data/system/imageSrcMap.js";
const imageSrcMap = getImageSrcMap();
let systemType = require("../../../config/system.js");

const map = {
    name: systemType.name,
    default: {
        themeColor: "#3DB8C5",
        title: "明树Apaas系统",
        logoUrl: imageSrcMap.system.logo.default,
        fixPhone: "010-86203077",
        fax: "010-86203077",
        email: "contacts@bridata.com",
        address: "北京朝阳区望京科技园F座502",
        zipCode: "100102",
        licenseNumber: "京ICP备17040877号",
        themeName: "明树云",
        loginBg: imageSrcMap.login.loginBg.default,
        registerBg: imageSrcMap.login.loginBg.default,
        optionStyle: {
            titleSize: 14,
            subTitleSize: 12,
            titleColor: "#5B5B5B",
            subTitleColor: "#878787",
            lineStyleColor: "#E7E6E9",
            lengendColor: "#555555",
            tooltipBgColor: "#fff"
        },
        evtableStyle: {
            titleBgColor: "#FAFBFD",
            oddBgColor: "#fff",
            evenBgColor: "#F7F9FC",
            rowHoverColor: "#F1F4FA",
            rowClickColor: "#F1F4FA"
        }
    },
    custom: {
        themeColor: "#3DB8C5",
        title: "明树Apaas自定义系统",
        logoUrl: imageSrcMap.system.logo.default,
        fixPhone: "010-86203077",
        fax: "010-86203077",
        email: "contacts@bridata.com",
        address: "北京朝阳区望京科技园F座502",
        zipCode: "100102",
        licenseNumber: "京ICP备17040877号",
        themeName: "明树云",
        loginBg: imageSrcMap.login.loginBg.default,
        registerBg: imageSrcMap.login.loginBg.default,
        optionStyle: {
            titleSize: 14,
            subTitleSize: 12,
            titleColor: "#5B5B5B",
            subTitleColor: "#878787",
            lineStyleColor: "#E7E6E9",
            lengendColor: "#555555",
            tooltipBgColor: "#fff"
        },
        evtableStyle: {
            titleBgColor: "#FAFBFD",
            oddBgColor: "#fff",
            evenBgColor: "#F7F9FC",
            rowHoverColor: "#F1F4FA",
            rowClickColor: "#F1F4FA"
        }
    },
    cscecGrey: {
        themeColor: "#4575ef",
        title: "八局系统",
        logoUrl: imageSrcMap.system.logo.cscec,
        fixPhone: "021-61691998",
        fax: "021-61691999",
        email: "cscec8b@cscec.com",
        address: "上海市浦东新区世纪大道1568号",
        zipCode: "200112",
        licenseNumber: "沪ICP备09023419号-3",
        themeName: "投建营一体化系统",
        loginBg: imageSrcMap.login.loginBg.cscec,
        registerBg: imageSrcMap.login.loginBg.cscec,
        poweredBy: "Powered by 明树",
        optionStyle: {
            titleSize: 16,
            subTitleSize: 14,
            titleColor: "#1A3868",
            subTitleColor: "#1A3868",
            lineStyleColor: "#E7E6E9",
            lengendColor: "#1A3868",
            tooltipBgColor: "#f8f8f8"
        },
        evtableStyle: {
            titleBgColor: "#ebebeb",
            oddBgColor: "#f8f8f8",
            evenBgColor: "#f0f0f0",
            rowHoverColor: "#ffffff",
            rowClickColor: "#ffffff"
        }
    }
};

export default map;



// WEBPACK FOOTER //
// ./src/data/system/platDataMap.js